import { type MessageTemplateContext } from '..';

export const SPOTLIGHT_CARD_WIDTH = 295;

export const TWC_SPOTLIGHT_TARGETS = {
	LINKED_VIDEO_PLAYER: 'linked-video-player',
	CONFLUENCE_CREATION_MODAL: 'confluence-creation-modal',
	CONFLUENCE_LINKED_PAGES: 'confluence-linked-pages',
} as const;

export const DEFAULT_TOUR: MessageTemplateContext['tour'] = {
	startFromStep: 0,
	steps: [
		{
			stepId: 'interactive-video',
			targetId: TWC_SPOTLIGHT_TARGETS.LINKED_VIDEO_PLAYER,
			dialogPlacement: 'right top',
		},
		{
			stepId: 'documentation',
			targetId: TWC_SPOTLIGHT_TARGETS.CONFLUENCE_LINKED_PAGES,
			dialogPlacement: 'right top',
		},
	],
};
